// Ringback tone played while an outbound call is ringing. SimpleUser attaches
// remote audio only once the call is established, so the FreeSWITCH ringback
// (early media) is never heard; this local tone fills that gap.
// Pattern: 425 Hz sine, 1 s on, 3 s off. Generated with Web Audio, no asset.

let ctx = null
let intervalId = null
let activeOsc = null
let activeGain = null

function getContext() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext
    if (!AC) return null
    ctx = new AC()
  }
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {})
  }
  return ctx
}

function playOne() {
  const ac = getContext()
  if (!ac) return

  const now = ac.currentTime
  const dur = 1.0
  const osc = ac.createOscillator()
  const gain = ac.createGain()

  osc.type = 'sine'
  osc.frequency.value = 425

  // Short attack/release to avoid audible clicks at tone boundaries.
  gain.gain.setValueAtTime(0, now)
  gain.gain.linearRampToValueAtTime(0.08, now + 0.04)
  gain.gain.linearRampToValueAtTime(0.08, now + dur - 0.04)
  gain.gain.linearRampToValueAtTime(0, now + dur)

  osc.connect(gain).connect(ac.destination)
  osc.start(now)
  osc.stop(now + dur + 0.02)

  activeOsc = osc
  activeGain = gain
}

export function startDialTone() {
  stopDialTone()
  try {
    playOne()
    intervalId = setInterval(playOne, 4000)
  } catch (err) {
    // Audio is a nicety; never let it break a call.
    stopDialTone()
  }
}

export function stopDialTone() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
  if (activeOsc) {
    try {
      activeOsc.stop()
    } catch (err) {}
    activeOsc = null
  }
  if (activeGain) {
    try {
      activeGain.disconnect()
    } catch (err) {}
    activeGain = null
  }
}
